import Input from './Input';
// import Password from './Password';
import Search from './Search';

export {
  Search
}
export default Input;